import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import CampaignForm from '@/components/Subscriptions/Campaign/CampaignForm/CampaignForm.vue';
import ICampaign from '@/interfaces/ICampaign';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component({
    name: 'CampaignDetail',
    components: {
        Loader,
        CardHeader,
        CampaignForm
    }
})
export default class CampaignDetail extends Vue {
    @Action private subscriptionsUpdateCampaign!: (form: ICampaign) => Promise<void>;
    @Action private subscriptionsGetCampaign!: (params: {id: string}) => Promise<ICampaign>;

    private campaignDataFromBackend: ICampaign | null =  null;

    private loading: boolean = false;

    private get campaignId() {
        return this.$route.params.id;
    }

    private get formData() {
        return this.campaignDataFromBackend;
    }

    private campaignUpdate(form: ICampaign) {
        this.subscriptionsUpdateCampaign(form);
    }

    private async getCampaignDetail(){
        this.loading = true;
        
        try {
            this.campaignDataFromBackend = await this.subscriptionsGetCampaign({id: this.campaignId})
        } catch (error) {
            console.error(error);
        }

        this.loading = false;
    }

    private async created() {
        try {
           await this.getCampaignDetail();
        } catch(error) {
            console.error(error);
        }
    }
}
